export default {"src":"/_next/static/media/500.6968b084.svg","height":174,"width":173,"blurWidth":0,"blurHeight":0};